<div class="navigation-progress" [ngClass]="{'navigation-progress--hidden': navigationType === 'hidden'}">
    <div class="navigation-progress-bar"
         [ngClass]="{'navigation-progress-bar--start': navigationType === 'start', 'navigation-progress-bar--full': navigationType === 'end' || navigationType === 'hidden'}">
    </div>
</div>
